export class KafkaTopicsProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bootstrapServers",
            "baseName": "bootstrapServers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfig",
            "format": ""
        },
        {
            "name": "nameFilter",
            "baseName": "nameFilter",
            "type": "string",
            "format": ""
        },
        {
            "name": "includeInternal",
            "baseName": "includeInternal",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaTopicsProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
